import { useTranslation } from 'react-i18next';
import React from 'react';

export const ApiLoading = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="loading-section">
        <div className="spin"></div>
        <p>{t('payment_processing')}</p>
      </div>
    </>
  );
};
export default ApiLoading;
